import { X } from "@phosphor-icons/react";
import { ModalProps } from "antd";
import React from "react";
import colors from "tailwindcss/colors";
import { Button, clsx, Modal } from "x-wings";

export type MobileModalPropsType = ModalProps & {};

//TODO: footer callback possibility is not handled
const MobileModal: React.FC<MobileModalPropsType> = (props) => {
	const { title, footer, children, className, styles, onCancel, closeIcon, closable } = props;

	const mergedStyles = Object.assign({}, styles, {
		content: Object.assign(
			{
				padding: "4px",
				paddingBottom: "0",
				borderRadius: "20px",
				background: "white",
				maxHeight: "80vh",
				display: "grid",
				gridTemplateRows: "min-content auto min-content",
				gridAutoFlow: "row",
				overflow: "auto"
			},
			styles?.content
		),
		footer: Object.assign({ margin: "12px 0 20px", padding: "0 12px" }, styles?.footer),
		header: Object.assign(
			{
				borderRadius: "16px 16px 4px 4px",
				padding: "16px",
				backgroundColor: colors.gray[200],
				margin: "0",
				overflow: "hidden"
			},
			styles?.header
		),
		body: Object.assign(
			{
				padding: "16px 12px",
				background: "unset",
				boxShadow: "unset"
			},
			styles?.body
		)
	});

	const titleElement = (
		<div className="relative text-start text-xl font-medium tracking-[-0.25px] text-[#171717]">
			<img src="./assets/SmvBg.svg" alt="smv-logo" className="absolute -bottom-4 -right-4" />
			{closeIcon !== false && closeIcon !== null && closable !== false && (
				<Button
					aria-label="Close"
					className="absolute right-0 top-0 z-[1000] !size-6 !min-w-6 !text-gray-700"
					shape="circle"
					icon={closeIcon ?? <X weight="bold" />}
					onClick={onCancel}
				/>
			)}
			{title}
		</div>
	);

	const showHeader = title || (closeIcon !== false && closeIcon !== null && closable !== false);

	const modalProps = Object.assign({}, props, {
		styles: mergedStyles,
		title: showHeader ? titleElement : undefined,
		footer: footer,
		className: clsx("absolute inset-x-0 bottom-0 top-[unset] !p-2", className),
		centered: undefined,
		closeIcon: false,
		children: children
	});

	return React.createElement(Modal, modalProps);
};

export default MobileModal;
